import { render, staticRenderFns } from "./AppsDefault.vue?vue&type=template&id=5d334052&scoped=true"
import script from "./AppsDefault.vue?vue&type=script&lang=js"
export * from "./AppsDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d334052",
  null
  
)

export default component.exports